import useLocale from 'next-translate/useTranslation';
import { FC, useState } from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import {
  atomDark,
  oneLight,
} from 'react-syntax-highlighter/dist/cjs/styles/prism';

interface Props {
  language: string;
  value: string;
}

export const CodeBlock: FC<Props> = ({ language, value }) => {
  const { t } = useLocale('common');

  const [buttonText, setButtonText] = useState(t('Copy') as string);
  const [theme, setTheme] = useState(() => {
    const theme =
      typeof window !== 'undefined' ? localStorage.getItem('theme') : null;

    if (
      theme === 'dark' ||
      (((typeof window !== 'undefined' && !('theme' in localStorage)) ||
        theme === 'system') &&
        window.matchMedia('(prefers-color-scheme: dark)').matches)
    ) {
      return 'dark';
    }

    return 'light';
  });

  const copyToClipboard = () => {
    navigator.clipboard.writeText(value).then(() => {
      setButtonText(t('Copied!'));

      setTimeout(() => {
        setButtonText(t('Copy'));
      }, 2000);
    });
  };

  return (
    <div className='relative text-[16px]' dir='ltr'>
      <SyntaxHighlighter
        language={language}
        style={theme === 'light' ? oneLight : atomDark}
        customStyle={{
          backgroundColor: theme === 'dark' ? '#293449' : 'auto',
        }}
      >
        {value}
      </SyntaxHighlighter>

      <button
        type='button'
        className='absolute right-2 top-2 rounded bg-primary-500 px-2 py-1 text-sm text-white hover:bg-primary-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2'
        onClick={copyToClipboard}
      >
        {buttonText}
      </button>
    </div>
  );
};
